import React from 'react';
import { SelectGroup, SelectItem, SelectLabel } from './ui/select';
import { Select, SelectContent, SelectTrigger, SelectValue } from './ui/select';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { getEstadoNome } from '../lib/utils';

// Retorna as zonas ([{nome, bairros}]) da cidade selecionada
export const getZonasDaCidade = (cidades, nomeCidade) => {
  const c = cidades.find((x) => x.nome === nomeCidade);
  return c?.zonas || [];
};

// Opções de cidade agrupadas por estado (com rótulo de região metropolitana, se houver)
export const CidadeSelectOptions = ({ cidades, currentValue }) => {
  const ufs = [...new Set(cidades.map((c) => c.estado || 'MG'))].sort();
  const nomes = cidades.map((c) => c.nome);
  return (
    <>
      {ufs.map((uf) => (
        <SelectGroup key={uf}>
          <SelectLabel>{getEstadoNome(uf)} ({uf})</SelectLabel>
          {cidades
            .filter((c) => (c.estado || 'MG') === uf)
            .map((c) => (
              <SelectItem key={c.id} value={c.nome}>
                {c.nome}{c.regiao_metropolitana ? ` · ${c.regiao_metropolitana}` : ''}
              </SelectItem>
            ))}
        </SelectGroup>
      ))}
      {currentValue && !nomes.includes(currentValue) && (
        <SelectItem value={currentValue}>{currentValue}</SelectItem>
      )}
    </>
  );
};

// Campos dinâmicos de Zona (select, quando a cidade tem zonas) e Bairro (texto opcional)
export const ZonaBairroFields = ({ cidades, cidade, zona, bairro, onZonaChange, onBairroChange, testPrefix = 'loc' }) => {
  const zonas = getZonasDaCidade(cidades, cidade);
  if (!cidade) return null;
  return (
    <>
      {zonas.length > 0 && (
        <div className="space-y-2">
          <Label>Zona / Região</Label>
          <Select value={zona || undefined} onValueChange={onZonaChange}>
            <SelectTrigger data-testid={`${testPrefix}-zona-select`}>
              <SelectValue placeholder="Selecione a zona" />
            </SelectTrigger>
            <SelectContent>
              {zonas.map((z) => (
                <SelectItem key={z.nome} value={z.nome}>{z.nome}</SelectItem>
              ))}
              {zona && !zonas.some((z) => z.nome === zona) && (
                <SelectItem value={zona}>{zona}</SelectItem>
              )}
            </SelectContent>
          </Select>
        </div>
      )}
      <div className="space-y-2">
        <Label>Bairro (opcional)</Label>
        <Input
          value={bairro || ''}
          onChange={(e) => onBairroChange(e.target.value)}
          placeholder="Ex: Tatuapé"
          data-testid={`${testPrefix}-bairro-input`}
        />
      </div>
    </>
  );
};
